<template>
  <v-container fluid class="overflow-y-auto">
    <v-row>
      <v-col cols="10" class="p-0 titleLarge d-flex align-center">
        <p class="opacity87">{{ $t('views.risk.title') }}</p>
      </v-col>
    </v-row>

    <RightBarRiskPopulation />
    <RightBarRiskBuildings />
    <!--RightBarRiskGnis :incident="incident" /-->
  </v-container>
</template>

<script setup lang="ts">
// Types Import
import type { Incident } from '@/types/Incident'

//Components Import
import RightBarRiskBuildings from './RightBarRiskBuildings.vue'
import RightBarRiskPopulation from './RightBarRiskPopulation.vue'
// import RightBarRiskGnis from "./RightBarRiskGnis.vue"

defineProps<{ incident: Incident }>()
</script>

<style scoped lang="scss">
:deep(.v-expansion-panel) {
  background-color: rgb(var(--v-theme-background));
  color: rgb(var(--v-theme-lighten));
  font-size: 12px;
}

:deep(.v-expansion-panel-title) {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
